// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "WPCloud",
    appLogoImage: require("@src/assets/images/liscr_logo.png"),
    successStatusImage: require("@src/assets/images/success_status.png"),
    errorStatusImage: require("@src/assets/images/error_status.png"),
    ziploader: require("@src/assets/images/loader.gif")
  },
  navicons: {
    menu1: require("@src/assets/images/dpp_menu_left.svg"),
    menu2: require("@src/assets/images/dpp_menu_left.svg"),

    arrival1: require("@src/assets/images/iconfinder-arrivals.png"),
    arrival2: require("@src/assets/images/iconfinder-arrivals1.png"),

    caseFile1: require("@src/assets/images/iconfinder-caseFiles.png"),
    caseFile2: require("@src/assets/images/iconfinder-caseFiles1.png"),

    preCheck1: require("@src/assets/images/iconfinder-preArrivalChecklist.png"),
    preCheck2: require("@src/assets/images/iconfinder-preArrivalChecklist1.png"),

    fleet1: require("@src/assets/images/nav_icons/menu_icons/fleet_2.png"),
    fleet2: require("@src/assets/images/nav_icons/menu_icons/fleet_1.png"),

    risk1: require("@src/assets/images/nav_icons/menu_icons/risk_1.png"),
    risk2: require("@src/assets/images/nav_icons/menu_icons/risk_2.png"),

    report1: require("@src/assets/images/nav_icons/menu_icons/reports_1.png"),
    report2: require("@src/assets/images/nav_icons/menu_icons/reports_2.png"),

    up1: require("@src/assets/images/nav_icons/menu_icons/upcoming_1.png"),
    up2: require("@src/assets/images/nav_icons/menu_icons/upcoming_2.png"),

    ports1: require("@src/assets/images/iconfinder-ports.png"),
    ports2: require("@src/assets/images/iconfinder-ports1.png"),

    email1: require("@src/assets/images/iconfinder-emailRule.png"),
    email2: require("@src/assets/images/iconfinder-emailRule1.png"),

    dataStatus1: require("@src/assets/images/iconfinder-icon-downloadStatistic.png"),
    dataStatus2: require("@src/assets/images/iconfinder-icon-downloadStatistic1.png"),

    admin1: require("@src/assets/images/iconfinder-administrator.png"),
    admin2: require("@src/assets/images/iconfinder-administrator1.png"),

    inspection1: require("@src/assets/images/iconfinder-inspection.svg"),
    inspection2: require("@src/assets/images/iconfinder-inspection.svg"),

    home1: require("@src/assets/images/home.png"),
    home2: require("@src/assets/images/home1.png"),

    user: require("@src/assets/images/navicons/user_profile.png")
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
